import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const CART_DISCOUNT_URL = `${CART_URL}/discount-code`;

export async function removeBuyNowDiscountCode(
  discountCode: string,
  cartId: string
): Promise<{ data: HttpCartDto }> {
  const expandParam =
    'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';
  return httpClient.delete(
    `${CART_DISCOUNT_URL}/${discountCode}?expand=${expandParam}`,
    {
      headers: {
        'x-cart-id': cartId
      }
    }
  );
}
